<template>
  <div>
    <div class="item-box">
      <btc-chart v-if="chartData" ref="chart" :data="chartData" :unit="unit" :is-en-expire="isEnExpire" title="Beef Exports to China" @click.native="handleCharts"/>
    </div>
    <div class="item-box" style="padding: 30px;">
      <div class="selector-box">
        <div class="selector-left">
          <selector :items="meatType" @tab-item="handleTabMeatType"/>
          <selector :items="storage" @tab-item="handleTabStorage"/>
        </div>
        <datetime v-if="startDate&&endDate" :start-date.sync="startDate" :end-date.sync="endDate" @tap-start="handleTapDate($event, 'StartDate')" @tap-end="handleTapDate($event, 'EndDate')"/>
      </div>
      <btc-table-header :data="header"/>
      <btc-table :data="list">
        <template v-slot="{ row }">
          <btc-table-cell :data="row">
            <template v-slot="{ cell }">
              <span>{{ cell.Origin }}</span>
            </template>
          </btc-table-cell>
          <btc-table-cell :data="row" @click.native="isLoginEnExpire">
            <template v-slot="{ cell }">
              <span>{{ cell.Volume }}</span>
            </template>
          </btc-table-cell>
          <btc-table-cell :data="row" @click.native="isLoginEnExpire">
            <template v-slot="{ cell }">
              <b-form-checkbox v-model="checkbox"
              :value="cell.Origin"
              :disabled="(checkbox.length === 1 && checkbox[0] === cell.Origin) || !isEnExpire || isLogin"
              plain
              @change="handleChangeCheckbox"/>
            </template>
          </btc-table-cell>
        </template>
      </btc-table>
    </div>
  </div>
</template>

<script>
import BtcTable from './components/table'
import BtcChart from './components/chart'
import Selector from './components/selector'
import Datetime from './components/datepicker'
import BtcTableHeader from './components/table/table-header'
import BtcTableCell from './components/table/table-cell'
import { getLocalStore } from '@/utils/common'
import commonmix from '@/utils/commonmix'

export default {
  mixins: [commonmix],
  name: 'ExportsToChina',
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    BtcTable,
    BtcChart,
    Selector,
    Datetime,
    BtcTableCell,
    BtcTableHeader
  },
  data () {
    return {
      unit: 'Unit: Ton',
      list: [],
      selected: [],
      selectLength: 0,
      checkbox: ['Brazil'],
      chartData: null,
      chartQuery: {
        UserID: getLocalStore().UserID,
        LanguageCode: 'en',
        IsFirst: false,
        Origin: 'Brazil',
        Type: '总计',
        Storage: '总计',
        isEn: true
      },
      tableQuery: {
        UserID: getLocalStore().UserID,
        LanguageCode: 'en',
        IsFirst: false,
        Origin: 'Brazil',
        Type: '总计',
        Storage: '总计',
        StartDate: '',
        EndDate: '',
        isEn: true
      },
      meatType: [
        { label: 'Total', value: '总计' },
        { label: 'Bone-in', value: '带骨' },
        { label: 'Boneless', value: '去骨' }
      ],
      storage: [
        { label: 'Total', value: '总计' },
        { label: 'Frozen', value: '冷冻' },
        { label: 'Chilled', value: '冰鲜' }
      ],
      header: [
        { label: 'Country', icon: require('@/assets/image/data/country.png') },
        { label: 'Export Volume (t)', icon: require('@/assets/image/data/volumn1.png') },
        { label: 'Comparison', icon: require('@/assets/image/data/contrast.png') }
      ],
      defaultVal: '',
      startDate: '',
      endDate: ''
    }
  },
  computed: {
    isLogin () {
      return this.$store.getters.token == null || this.$store.getters.token === ''
    },
    isEnExpire () {
      return this.getUserProfile(this.$t('message._btcdata_en'))
    }
  },
  mounted () {
    this.getChartData(true)
    // this.getTableData()
  },
  methods: {
    getChartData (isTable = false, fn) {
      this.$store.dispatch('SetLoadingStatus', true)
      this.$store.dispatch('GetBeefWebDataOneChart', this.chartQuery).then(() => {
        this.chartData = this.$store.getters.dataChart
        this.startDate = this.chartData.tableEndDate
        this.endDate = this.chartData.tableEndDate
        this.tableQuery.StartDate = this.endDate.replace('-', '')
        this.tableQuery.EndDate = this.endDate.replace('-', '')
        if (fn) {
          fn(this.chartData)
        }
        if (isTable) {
          this.getTableData()
        }
        this.$store.dispatch('SetLoadingStatus', false)
      }).catch((err) => {
        this.$store.dispatch('SetLoadingStatus', false)
        console.error(err)
      })
    },
    getTableData (refresh) {
      this.$store.dispatch('SetLoadingStatus', true)
      this.$store.dispatch('GetBeefWebDataOneTable', this.tableQuery).then(() => {
        this.list = this.$store.getters.dataTable.tableData
        this.defaultVal = this.$store.getters.dataTable.Origin
        if (refresh) {
          this.checkbox = [this.defaultVal]
          this.chartQuery.Origin = this.defaultVal
          this.getChartData(false, (data) => {
            this.$refs.chart.refreshData(data)
          })
        }
        this.$store.dispatch('SetLoadingStatus', false)
      }).catch((err) => {
        console.error(err)
        this.$store.dispatch('SetLoadingStatus', false)
      })
    },
    handleTabMeatType (item) {
      this.tableQuery.Type = item.value
      this.chartQuery.Type = item.value
      this.getTableData(true)
    },
    handleTabStorage (item) {
      this.tableQuery.Storage = item.value
      this.chartQuery.Storage = item.value
      this.getTableData(true)
    },
    handleChangeCheckbox (e) {
      this.selected = e
      this.selectLength = e.length
      if (this.selectLength === 0) {
        return
      }
      if (this.selectLength > 5) {
        e.shift()
      }
      this.chartQuery.Origin = e.join('|')
      this.getChartData(false, (data) => {
        this.$refs.chart.refreshData(data)
      })
    },
    handleTapDate (date, type) {
      this.tableQuery[type] = date
      this.getTableData()
    },
    handleCharts () {
      if (this.$store.getters.token) {
        if (!this.isEnExpire) {
          this.openMembershipModal()
        }
      } else {
        this.openLoginModal()
      }
    },
    isLoginEnExpire () {
      if (this.$store.getters.token) {
        if (!this.isEnExpire) {
          this.openMembershipModal()
        }
      } else {
        this.openLoginModal()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.item-box {
  min-height: 420px;
  margin: 20px;
  padding-top: 20px;
  border-radius: 20px;
  background-color: #ffffff;
}

// 筛选
.selector-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.selector-left {
  display: flex;
  justify-content: space-between;
}
</style>
